"use client";

import { DateInput as HeroDateInput } from "@heroui/react";
import { cn } from "../../lib/utils";

export const DateInput = ({
  className,
  ...props
}: { className?: string } & React.ComponentProps<typeof HeroDateInput>) => {
  return <HeroDateInput className={cn(className)} {...props} />;
};
